import { render, staticRenderFns } from "./EditAppearance.vue?vue&type=template&id=45ab837b&scoped=true"
import script from "./EditAppearance.vue?vue&type=script&lang=js"
export * from "./EditAppearance.vue?vue&type=script&lang=js"
import style0 from "./EditAppearance.vue?vue&type=style&index=0&id=45ab837b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ab837b",
  null
  
)

export default component.exports